import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import { rHaritadaAra } from '../../models/rHaritadaAra';
import rList from '../../models/rList';

export default class HaritadaAraApi extends ApiBase<pList, rList<rHaritadaAra>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/HaritadaAra',
      }),
      options
    );
  }
}
